import { StepWizardStep } from "../../../../../../commons/StepWizard/StepWizard.types";
import CreateAccountManuallyForm from "../CreateAccountManuallyButton/CreateAccountManuallyForm/CreateAccountManuallyForm";
import ProspectPaymentForm from "./CreateAccountPaymentStep/ProspectPaymentForm/ProspectPaymentForm";
import ProspectPaymentFrame from "./CreateAccountPaymentStep/ProspectPaymentFrame/ProspectPaymentFrame";

export const createAccountManuallySteps: StepWizardStep[] = [
    {
      step: 1,
      component: CreateAccountManuallyForm,
      title: 'Informations de base',
      subtitle: 'Renseignez les informations de base de la consultation',
    },
    {
      step: 2,
      component: ProspectPaymentForm,
      title: 'Informations de base',
      subtitle: 'Renseignez les informations de base de la consultation',
    },
    {
      step: 3,
      component: ProspectPaymentFrame,
      title: 'Informations de base',
      subtitle: 'Renseignez les informations de base de la consultation',
    }
  ];